<template>
  <el-dialog :title="vendorName + '购买明细'"
             :visible.sync="visible"
             width="900px"
             @close='handleClose'
             :close-on-press-escape="false">
    <el-table border
              v-loading="loading"
              :data="list">
      <el-table-column label="套码序号"
                       fixed="left"
                       min-width="170">
        <template slot-scope="{row}">
          {{row.beginSetNo | tagCount() }} - {{row.endSetNo | tagCount() }}
        </template>
      </el-table-column>
      <el-table-column label="标签类型"
                       min-width="100">
        <template slot-scope="{row}">
          {{row.tagType | tagType()}}
        </template>
      </el-table-column>
      <el-table-column label="包装规格"
                       min-width="80">
        <template slot-scope="{row}">
          {{row.corratio}}个/套
        </template>
      </el-table-column>
      <el-table-column label="装箱规格"
                       min-width="80">
        <template slot-scope="{row}">
          <span v-if="row.boxCorratio"> {{row.boxCorratio }}套/箱</span>
        </template>
      </el-table-column>
      <el-table-column label="套码(标签)数量"
                       min-width="120">
        <template slot-scope="{row}">
          {{row.setCount}}套({{row.tagCount}}个)
        </template>
      </el-table-column>
      <el-table-column label="剩余数量"
                       min-width="100">
        <template slot-scope="{row}">
          {{row.remainSetCount}}套({{row.remainCount}}个)
        </template>
      </el-table-column>
      <el-table-column label="购买时间"
                       width="150">
        <template slot-scope="{row}">
          {{row.createdTime | dateformat() }}
        </template>
      </el-table-column>
      <el-table-column label="操作"
                       fixed="right"
                       width="60">
        <template slot-scope="{row}">
          <el-button type="text"
                     @click="downloadsetsegment(row)">下载</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination background
                   @current-change="handleCurrentChange"
                   :current-page.sync="config.pageNum"
                   :page-size="config.pageSize"
                   layout="total, prev, pager, next"
                   :total="total">
    </el-pagination>
    <template slot="footer">
      <el-button @click="toggleModal(false)"
                 :loading="loading">关 闭</el-button>
    </template>
  </el-dialog>
</template>
<script>
export default {
  name: 'ent-set-detail-modal',
  components: {},
  data () {
    return {
      loading: false,
      visible: false,
      vendorName: '',
      config: {
        vendorId: null,
        pageNum: 1,
        pageSize: 10,
        isPreassign: 1
      },
      list: [],
      total: 0
    }
  },
  methods: {
    toggleModal (visible) {
      this.visible = visible
    },
    handleClose () {
      this.list = []
      this.total = 0
      this.config.pageNum = 1
      this.config.vendorId = null
    },
    downloadsetsegment (row) {
      this.loading = true
      this.$store.dispatch('label/downloadsetsegment', {
        payload: {
          setSegId: row.setSegId,
          setSegDetailsId: row.setSegDetailsId
        },
        success: (res) => {
          this.loading = false
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    getsetassigns (cb) {
      this.loading = true
      this.$store.dispatch('label/getsetsegmentdetailses', {
        payload: this.config,
        success: (res) => {
          this.loading = false
          this.list = res.data.records
          this.total = res.data.total
          cb && cb()
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    handleCurrentChange (current) {
      this.config.pageNum = current
      this.getsetassigns()
    },
    fetch (options) {
      this.config.vendorId = options.vendorId
      this.vendorName = options.vendorName
      this.getsetassigns(() => {
        this.toggleModal(true)
      })
    }
  }
}
</script>
